import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
`;

export const KeyList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  padding: 0;
`;

export const IndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 14px;
  font-size: 1.3rem;

  span {
    text-transform: capitalize;
  }
`;

export const Indicator = styled.li<{ name?: string }>`
  list-style-type: none;
  border-radius: 50%;
  width: 0.7rem;
  height: 0.7rem;
  margin-right: 0.8rem;

  background: ${(props) => {
    if (props.name === "won") return props.theme.formWin;
    if (props.name === "push") return props.theme.push;
    if (props.name === "lost") return props.theme.formLoss;
    if (
      props.name === "last_season_win" ||
      props.name === "last_season_lost" ||
      props.name === "last_season_push"
    )
      return "none";
  }};
  border: ${(props) => {
    if (props.name === "last_season_win")
      return `1px solid ${props.theme.formWin}`;
    if (props.name === "last_season_lost")
      return `1px solid ${props.theme.formLoss}`;
    if (props.name === "last_season_push")
      return `1px solid ${props.theme.push}`;
  }};
`;
